import { Document, Page } from "react-pdf";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { Show } from "shared/components";

const isImage = (url: string) => {
  return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
};

const PAGE_WIDTH = 908;

export const DocumentPDFViewer = ({ applicantId }: { applicantId: number }) => {
  const [numPages, setNumPages] = useState<number[]>([]);

  const { data, isLoading, isError } = useQuery({
    queryFn: () =>
      instance
        .get(`/portal/v1/applicants/${applicantId}/additional_documents`)
        .then(({ data }) => data),
    queryKey: ["ADDITIONAL_DOCUMENTS", applicantId]
  });

  if (isLoading)
    return <p className="text-base text-content-400">Loading documents...</p>;

  return (
    <div className="hidden print:block">
      <Show if={isError}>
        <div className="flex justify-center">
          <h3 className="text-content-1000 font-medium my-2">
            Error loading additional documents
          </h3>
        </div>
      </Show>
      {data?.items?.map((doc, idx) => (
        <div
          key={doc.id}
          className="flex justify-center"
          style={{ pageBreakAfter: "always" }}
        >
          {isImage(doc.asset_name) ? (
            <img
              src={doc.asset_url}
              alt={`image-${doc.id}`}
              className="max-w-full"
            />
          ) : (
            <Document
              file={doc.asset_url}
              onLoadSuccess={({ numPages: num }) => {
                const pages = [...numPages];
                pages[idx] = num;
                setNumPages(pages);
              }}
            >
              {Array.from(new Array(numPages[idx]), (el, pageIndex) => (
                <Page
                  key={pageIndex}
                  pageNumber={pageIndex + 1}
                  width={PAGE_WIDTH}
                />
              ))}
            </Document>
          )}
        </div>
      ))}
    </div>
  );
};
